import { ROUTE } from "@/types/router";
import { Navigate, Outlet } from "react-router-dom";

interface PrivateRouteProps {
  isAuth: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ isAuth }) => {
  return isAuth ? <Outlet /> : <Navigate to={ROUTE.Login} replace />;
};

export default PrivateRoute;
